import React, { useState } from 'react';
import FloatInput from 'components/generic-components/FloatInput';
import CustomButton from 'components/generic-components/ButtonComponent';
import SelectModal from 'components/SelectModal';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import {
    PAYMENTS
} from '../../../../constants/routes';
import PaymentHistory from './PaymentHistory';

const UnregisteredLayout = ({ view, isPaymentHistory }) => {
    const [show, setShow] = useState(false);
    const { t } = useTranslation();



    React.useEffect(() => {

    }, []);

    return (
        <div className={'unregister-container'} >
            {
                view ?
                    <>

                        <div className="unregister-header"><h2>{t(`Your card`)}</h2></div>
                        <div className="unregister-card-content">
                            <p>{t(`Please`)} <span><Link to={PAYMENTS}>{t(`add a new card`)}</Link> </span>{t(`to subscribe to other users or recharge your wallet`)}</p>
                            <p className="payment-text-complaint">{t(`PAYMENT_COMPLIANT`)}</p>
                            <p className="payment-text-charges">{t(`CHARGES_APPEAR`)}</p>

                        </div>
                    </>






                    :
                    <>
                        <div className="unregister-header"><h2>{t(`Payments`)}</h2></div>
                        <div className="unregister-payment-content">
                            {isPaymentHistory ? isPaymentHistory.slice().reverse().map(item => <PaymentHistory isPaymentHistory={item} />) : <p>{t(`You haven’t made any payments yet`)}</p>}
                            <p className="payment-text-complaint">{t(`PAYMENT_COMPLIANT`)}
                            </p>
                            <p className="payment-text-charges">{t(`CHARGES_APPEAR`)}</p>

                        </div>

                    </>
            }
        </div>
    );
};

export default UnregisteredLayout;
